import { useSelector } from "react-redux"
import { printServiceProductsSelector } from "~/redux/state/printServiceProducts"
import { RootState } from "~/redux/store"

const getAllProducts = (state: RootState) => {
  return printServiceProductsSelector.selectEntities(state)
}

export const useAllProducts = () => {
  const products = useSelector(getAllProducts)
  return products
}
